$(document).ready(function(){
    $(".form-show-button").click(function(){
        $("#support-buttons").hide();
        $(this).parent().next('#support-forms').find("." + $(this).attr('data-button')).show();
    });

    $(".cancel").click(function() {
        $(this).closest('form').find("input[type=text], textarea, input[type=password]").val("");
    });
});